module.exports = __webpack_public_path__ + "img/collab4.d86309d9.jpg";